import { REDUCER } from '../reducers/reducersConst';

let defaultComponentState = {
  fetching: false,
  menuIsOpen: false,
  activeLoader: false
};

export let components = (state = defaultComponentState, action) => {
  switch (action.type) {
    case REDUCER.COMPONENTS.FETCHING:
      return {
        ...state,
        fetching: action.fetching
      };
    case REDUCER.COMPONENTS.PREVIOUS_ROUTE:
      return {
        ...state,
        previousRoute: action.previousRoute
      };
    case REDUCER.COMPONENTS.SET_MENU_OPEN:
      return {
        ...state,
        menuIsOpen: action.menuIsOpen
      };
    case REDUCER.COMPONENTS.SET_ACTIVE_LOADER:
      return {
        ...state,
        activeLoader: action.activeLoader
      };
    default:
      return state;
  }
};
